export const ADMIN_INVOICES_SLICE_NAME = "adminInvoices"
